import { useCallback, useEffect } from 'react'
import { APP_TYPE } from 'shared/config'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useChangeFavicon = () => {
  const { inboxesStore } = useEntitiesContext()
  const unread = inboxesStore.unreadMessagesCount
  const setIcon = useCallback((value: 'read' | 'unread') => {
    const elementLink = document.querySelector('link[rel=icon]')

    if (!elementLink) return
    if (value === 'unread') {
      elementLink.setAttribute(
        'href',
        `${window.location.origin}/images/icons/unread/favicon-32x32.png`
      )
    } else {
      elementLink.setAttribute('href', `${window.location.origin}/images/icons/favicon-32x32.png`)
    }
  }, [])

  useEffect(() => {
    if (APP_TYPE !== 'vue') {
      setIcon(unread ? 'unread' : 'read')
    }
  }, [unread])
}
